const storeActions = Object.freeze({
    initState: 'initState',
    setLanguage: 'setLanguage',
    setAspectRatio: 'setAspectRatio',
    setVideoQualityProfile: 'setVideoQualityProfile',
    setDownloadProfile: 'setDownloadProfile',
    setShowMobileNetworkWarning: 'setShowMobileNetworkWarning',
    setVideoStreamingOverCellular: 'setVideoStreamingOverCellular',
    setDownloadsOverCellular: 'setDownloadsOverCellular',
    setAutoParentalLockInterval: 'setAutoParentalLockInterval',
    setAutoPlayNextItem: 'setAutoPlayNextItem',
    setRememberPassword: 'setRememberPassword',
    setOnboardingCompleted: 'setOnboardingCompleted',
    setParentalControlLocked: 'setParentalControlLocked',
    setShowEnforceChangePassword: 'setShowEnforceChangePassword',
    setCookieConsent: 'setCookieConsent',
    setEpgSelectedListMode: 'setEpgSelectedListMode',
    setDataSaverValue: 'setDataSaverValue',
    setPlayerVolume: 'setPlayerVolume',
    setIsNewFeaturesChecked: 'setIsNewFeaturesChecked'
});

export default storeActions;
